import React, { useState, useContext } from 'react'
import { useEffect } from 'react'
import { CategoriesContext, LawyerContext } from '../../../../partials/Context'
import AddCaseForm from './AddCaseForm'
import EditCaseForm from './EditCaseForm'
import {getLawyer} from '../../../../functions/api';
import { Errors } from '../../../../partials/Partials';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

function Cases() {
    const [display_form, setDisplayForm] = useState(false);
    const [display_edit_form, setDisplayEditForm] = useState(false);
    const [current_case_id, setCurrentCaseId] = useState(0);
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState(0);
    const [tags, setTags] = useState('');
    const lawyer = useContext(LawyerContext)
    const [lawyer_data, setLawyerData] = useState({});
    const {cases} = lawyer_data || ''
    const categories_all = useContext(CategoriesContext)
    const [errors, setErrors] = useState([])
    let cases_list = [];
    let finished_categories = [];
    let descriptions = [];

    useEffect(() => {
        setLawyerData(lawyer)
    }, [lawyer])

    const getCurrentLawyer = () => {
        getLawyer(setLawyerData, setErrors);
    }

    const getCaseById = (id) => {
        for (const cs of cases) {
            if (cs.id === id) {
                return cs;
            }
        }
        return null;
    }

    const setCase = (id) => {
        const cs = getCaseById(id);
        setCurrentCaseId(id);
        setDescription(cs.description);
        setCategory(cs.category);
        setTags(cs.tags);
    }

    const updateCase = (id) => {
        setCase(id);
        setDisplayForm(false);
        setDisplayEditForm(true);
    }

    if(cases)
    cases.forEach(item => {  
        if (finished_categories.indexOf(item.category) === -1) {
            const obj = {
                category_id: item.category,
                cases: [{id: item.id, description: item.description}],
            }
            finished_categories.push(item.category)
            descriptions.push(obj)
        } else {
            descriptions.forEach(finished_category => {
                if (finished_category.category_id === item.category) {
                    finished_category.cases.push({id: item.id, description: item.description})
                }
            })
        }
    })

    const getCategoryPropertyById = (id, prop) => {
        let category_prop = ''
        Object.keys(categories_all).forEach(array_name => {
            categories_all[array_name].forEach(category => {
                if (id === category.id) {
                    category_prop = category[prop]
                }
            })
        })
        return category_prop
    }

    descriptions.forEach((description, index) => {
        let category_name = getCategoryPropertyById(description.category_id, 'name')
        let category_icon = getCategoryPropertyById(description.category_id, 'icon_url')
        let category_type_name = getCategoryPropertyById(description.category_id, 'type_name')
        let font_color = '';
        let count_cases = description.cases.length;
        let descriptions_list = [];
        let tags_string = '';

        if (getCategoryPropertyById(description.category_id, 'annotation')) {
            tags_string = `(${getCategoryPropertyById(description.category_id, 'annotation')})`;
        }
        

        if(category_type_name === 'prywatny') {
            font_color = '#ad3383'
        } else {
            font_color = '#135d9e'
        }

        description.cases.forEach((item, i) => {
            descriptions_list.push(
                <p key={i} onClick={() => {updateCase(item.id)}}>{item.description}</p>
            )
        })
        
        cases_list.push(
            <div className="cases-list-item" key={index}>
                {/*    Sprawdza, czy url do ikonki jest kompletny.
                       Przykładowy url - /media/img/problemsIcons/inne-prywatne.png   */}
                {category_icon.split('/').length > 3?
                    <img src={category_icon} alt="kategoria"/>
                    : <span style={{width: '40px'}}></span>
                }
                <div className="rest">
                    <div className="rest-title" style={{color: `${font_color}`}}>
                        {category_name}&nbsp; 
                        <span className="tags">{tags_string}</span>
                        &nbsp;({count_cases})
                    </div>
                    {descriptions_list}
                </div>
            </div>
        )
    })

  return (
    <div className="finished-cases profile-section">
        <h1 className="title">Sprawy przeprowadzone
        <button className="add-case" onClick={() => {
            setDisplayForm(!display_form);
            setDisplayEditForm(false);
        }}>Dodaj sprawę</button>
        </h1>
        <Errors errors={errors} />
        {display_form ?
            <AddCaseForm getCurrentLawyer={getCurrentLawyer}/>
            : null 
        }
        {display_edit_form ?
            <EditCaseForm getCurrentLawyer={getCurrentLawyer} caseId={current_case_id} description={description}
                setDescription={setDescription} category={category} setCategory={setCategory}
                tags={tags} setTags={setTags} setDisplayEditForm={setDisplayEditForm}/>
            : null
        }
        {cases_list.length > 0 ?
        <div className="cases-list" >
            {cases_list}
        </div>
        : !display_form ? 
            <div className="sp-tooltip blue tooltip-block bottom tooltip in">
                <div className="tooltip-arrow"></div>
                <div className="tooltip-inner">
                    <div>
                    <FontAwesomeIcon icon={faInfoCircle} className='fa-3x fa-triangle'/>
                    </div>
                    <div className="tooltip-text col-sm-11">
                        <i className="fa fa-info-circle fa-2x"></i><div>Myśl strategicznie o swojej praktyce<br/>Daj się poznać jako ekspert w swojej dziedzinie<br/><strong>87%</strong> klientów kieruje się doświadczeniem prawnika</div>
                    </div>
                </div>
            </div> : null}
    </div>
  )
}

export default Cases;

